import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  Contractor,
  InspectionInstallation
} from '@authority-labs/api-interfaces';
import { Conclusion } from '@authority-labs/enums';

@Component({
  selector: 'authority-labs-certificate-installation',
  templateUrl: './certificate-installation.component.html',
  styleUrls: ['./certificate-installation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificateInstallationComponent implements OnInit {
  @Input() contractor: Contractor;
  @Input() inspection: InspectionInstallation;
  @Input() inspectionDate: Date;

  notes: string[] = [];

  get waterNetworkCharacterizationStatus(): string {
    if (
      this.inspection?.waterNetworkCharacterization?.isApplicable &&
      this.inspection?.waterNetworkCharacterization?.testData?.length > 0
    ) {
      return this.inspection?.waterNetworkCharacterization.testData[0].isPassed
        ? Conclusion.Pass
        : Conclusion.Fail;
    }

    return Conclusion.NotApplicable;
  }

  constructor() {}

  ngOnInit(): void {
    this.notes = this.inspection
      .getNotes()
      .filter((note) => note.addNotesToReport && note.notes)
      .map((note) => note.notes);
  }

  addMetric(value: number, metric: string = ''): string {
    return value ? `${value}${metric}` : '--';
  }
}
